// The current application coordinates were pre-registered in a B2C tenant.
export let apiConfig = {
    b2cScopes: [
        'https://rekomgroupb2c.onmicrosoft.com/rekom-life-admin-api/admin.readwrite'
    ],
    //webApi: "https://fabrikamb2chello.azurewebsites.net/hello"
};